module.exports = __webpack_public_path__ + "static/img/avage.1319e4b7.png";